<script lang="ts">
    export let onClose: () => void;
</script>

<button
    class="absolute right-0 top-0 z-10 m-6 flex h-8 w-8 items-center justify-center rounded-full bg-gray-900/40"
    on:click={onClose}
>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24px"
        height="24px"
        class="svg"
        ><path d="M0 0h24v24H0z" fill="none" />
        <path
            d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
        />
    </svg>
</button>

<style lang="scss">
    .svg {
        fill: #f0f0f0;
    }
</style>
